export default function () {
  this.restoreActiveRefund()
}
